// src/Countdown.js
import React, { useState, useEffect } from 'react';

const Countdown = ({ onCountdownComplete }) => {
    const [count, setCount] = useState(3);

    useEffect(() => {
        if (count > 0) {
            const timer = setTimeout(() => setCount(count - 1), 600);
            return () => clearTimeout(timer);
        } else {
            onCountdownComplete();
        }
        // console.log("Count", count);
    }, [count, onCountdownComplete]);

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75">
            <div className="text-white text-4xl font-bold">
                Completed! Redirecting in {count}...
            </div>
        </div>
    );
};

export default Countdown;